/** Module key for sections that can be turned on/off via app settings. */
export type ModuleKey = 'Automation' | 'Governance' | 'Integrations';

/**
 * Path prefixes that belong to each feature module.
 * Used by ModuleGuard to redirect when a module is disabled.
 */
const MODULE_PATH_PREFIXES: { prefix: string; module: ModuleKey }[] = [
  { prefix: '/workflows', module: 'Automation' },
  { prefix: '/composer', module: 'Automation' },
  { prefix: '/schedules', module: 'Automation' },
  { prefix: '/investigations', module: 'Automation' },
  { prefix: '/safety-gates', module: 'Governance' },
  { prefix: '/approval-queue', module: 'Governance' },
  { prefix: '/guardrails', module: 'Governance' },
  { prefix: '/mcp-servers', module: 'Integrations' },
  { prefix: '/external-systems', module: 'Integrations' },
  { prefix: '/connectors', module: 'Integrations' },
  { prefix: '/web-automation', module: 'Integrations' },
];

/**
 * Returns the module key for a given pathname, or null if the path is not under a toggleable module.
 */
export function getModuleForPath(pathname: string): ModuleKey | null {
  const normalized = pathname.split('?')[0];
  for (const { prefix, module } of MODULE_PATH_PREFIXES) {
    if (normalized === prefix || normalized.startsWith(prefix + '/')) {
      return module;
    }
  }
  return null;
}
